import {
  FETCH_NEIGHBORHOOD_LOCATION,
  FETCH_NEIGHBORHOOD_LOCATION_ERROR,
  CLEAN_NEIGHBORHOOD_LOCATION,
  CLEAN_NEIGHBORHOOD_LOCATION_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function neighborhoodLocationReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_NEIGHBORHOOD_LOCATION:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case FETCH_NEIGHBORHOOD_LOCATION_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_NEIGHBORHOOD_LOCATION:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_NEIGHBORHOOD_LOCATION_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
